<div>
    <ng-container *ngIf="type === 'key-point-list'
            || type === 'hero-section'
            || type === 'external-html-content'
            || type === 'faq-list'
            || type === 'text-only'
            || type === 'dual-text'
            || type === 'middle-media-sides-text';
            else regularBanner">
        <div *ngIf="type === 'text-only'">
            <vsf-text-only-banner
                [titleInfo]="titleInfo"
                [banner]="marketingBanner"
                [linePadding]="linePadding"
                [isMobile]="isMobile"
                [pageFullWidth]="pageFullWidth"
                [sectionMaxHeight]="sectionMaxHeight">
            </vsf-text-only-banner>
        </div>
        <div *ngIf="type === 'dual-text' || type === 'middle-media-sides-text'">
            <vsf-dual-text-banner
                [titleInfo]="titleInfo"
                [banner]="marketingBanner"
                [linePadding]="linePadding"
                [isMobile]="isMobile"
                [pageFullWidth]="pageFullWidth"
                [sectionMaxHeight]="sectionMaxHeight">
            </vsf-dual-text-banner>
        </div>
    </ng-container>
    <ng-template #regularBanner>
        <div class="product-marketing-banner"
            [ngStyle]="sectionMaxHeight && sectionMaxHeight !== 'none'
                ? {'background-color': backgroundColor, 'max-height': sectionMaxHeight, overflow: 'hidden', 'display': 'flex', 'flex-direction': 'column', 'justify-content': 'center'}
                : {'background-color': backgroundColor}"
            [ngClass]="[sectionRoundedClass, pageFullWidth ? 'content-constrained' : '']">
            <div *ngIf="type === 'left-media-right-text'" class="banner-container left-media-right-text w-full">
                <div *ngIf="!isMobile" class="flex flex-row relative w-full">
                    <div class="banner-background overflow-hidden" *ngIf="backgroundMedia">
                        <img *ngIf="backgroundMedia.type === 'IMAGE'"
                            [src]="backgroundMedia | assetPreview:'full':'webp'"
                            [alt]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Image'"
                            class="w-full h-full object-cover"
                            [style.object-position]="backgroundMedia | focalPoint"
                            [style.opacity]="shadowTransparencyValue"
                        />
                        <video *ngIf="backgroundMedia.type === 'VIDEO' && backgroundMedia.mimeType === 'video/mp4'"
                            [src]="backgroundMedia.source"
                            class="banner-background-video"
                            autoplay muted loop playsinline>
                            Your browser does not support the video tag. Please view the video content elsewhere.
                        </video>
                        <vsf-vimeo-player *ngIf="backgroundMedia.type === 'VIDEO' && backgroundMedia.mimeType === 'video/vimeo'"
                            [source]="backgroundMedia.customFields?.videoUrl || backgroundMedia.source"
                            [width]="backgroundMediaWidth"
                            [previewImageUrl]="backgroundMedia.imageUrl || backgroundMedia.preview"
                            [previewAltText]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Video'">
                        </vsf-vimeo-player>
                    </div>
                    <div class="inner flex flex-col w-full relative z-[2]"
                       [style.padding]="linePadding"
                    >
                    <div>
                        <vsf-title-box
                            [titleInfo]="titleInfo"
                            [forComponent]="true">
                        </vsf-title-box>
                    </div>
                    <div class="flex flex-row">
                        <div class="media-container"
                            [ngClass]="{ 'mr-10':  mediaTextGap === 0 }"
                            [style.height.px]="mediaHeight"
                            [ngStyle]="{'width': calculateWidths().media, 'margin-right': mediaTextGap > 0 ? mediaTextGapInPx : null }">
                            <div class="media-item">
                                <ng-container *ngIf="isBrowser; else fallbackImage">
                                    <swiper-container appSwiper #leftMediaDesktopSwiper pagination.type="progressbar" pagination-clickable="true"
                                        centered-slides="true" lazy="true"
                                        rewind="true" class="flex-grow object-cover custom-pagination">
                                        <swiper-slide *ngFor="let media of bannerMedias"
                                            class="w-full h-full"
                                            [style.height.px]="mediaHeight"
                                        >
                                            <div class = "flex items-center w-full h-full"
                                                [ngClass]="{'justify-end'  : mediaTextGap > 0, 'justify-start': mediaTextGap == 0 }">
                                                <div *ngIf="media.type === 'IMAGE'">
                                                    <img [src]="media | assetPreview:'large':'webp'"
                                                        [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                        loading="eager"
                                                        style="pointer-events: none"
                                                        [style.height.px]="mediaHeight"
                                                        [width]="media.width"
                                                        [height]="media.height"
                                                        class="swiper-lazy w-full h-full object-contain"
                                                        [ngClass]="roundedClass"/>
                                                    <div class="swiper-lazy-preloader"></div>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                                                    <video [muted]="true"
                                                        class="object-cover w-full h-full object-contain"
                                                        style="pointer-events: none"
                                                        [style.height.px]="mediaHeight"
                                                        autoplay loop playsinline>
                                                        <source [src]="media.source" type="video/mp4">
                                                        Your browser does not support the video tag. Please view the video content elsewhere.
                                                    </video>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'" class="w-full h-full">
                                                    <vsf-vimeo-player
                                                        [source]="media.customFields?.videoUrl || media.source"
                                                        [height]="mediaHeight"
                                                        [width]="mediasWidth"
                                                        [fullSection]="true"
                                                        [withMouseHover]="true"
                                                        [previewImageUrl]="media.imageUrl || media.preview"
                                                        [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                                                    </vsf-vimeo-player>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper-container>
                                </ng-container>
                            </div>
                        </div>
                        <div class="text-container flex flex-col justify-center"
                            [ngStyle]="{ 'width': calculateWidths().text, 'text-align': textAlignment }">
                            <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="order-1 font-bold mb-3 rich-text-content"
                                [ngStyle]="{ 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                                [innerHTML]="title | safeHtml">
                            </h1>
                            <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="order-1 font-bold mb-3 rich-text-content"
                                [ngStyle]="{ 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                                [innerHTML]="title | safeHtml">
                            </div>
                            <div class="mb-4 order-2 rich-text-content"
                                [ngStyle]="{'margin-left': textIndentation,'width': textWidth,'font-size.px': textFontSize}"
                                [innerHTML]="text | safeHtml"></div>
                            <div *ngIf="button?.enabled && buttonPosition === 'below-text'"
                                class="flex flex-row mt-4 order-3"
                                [ngClass]="{
                                    'w-full justify-start': buttonAlignment === 'left',
                                    'w-full justify-end': buttonAlignment === 'right'
                                }"
                            >
                                <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                            </div>
                        </div>
                        <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                            <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                        </div>
                    </div>

                    </div>
                </div>
                <div *ngIf="isMobile" class="w-full">
                  <div *ngIf="layoutStyle === 'normal'; else gridLayout">
                    <div class="flex flex-col" [style.padding]="linePadding">
                        <div>
                            <vsf-title-box
                                [titleInfo]="titleInfo"
                                [forComponent]="true">
                            </vsf-title-box>
                        </div>
                        <div class="flex flex-row overflow-hidden relative">
                            <div class="banner-background" *ngIf="backgroundMobileMedia">
                                <img *ngIf="backgroundMobileMedia.type === 'IMAGE'"
                                    [src]="backgroundMobileMedia | assetPreview:'medium':'webp'"
                                    [alt]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Image'"
                                    class="w-full h-full object-cover"
                                    [style.object-position]="backgroundMobileMedia | focalPoint"
                                    [style.opacity]="shadowTransparencyValue"
                                />
                                <video *ngIf="backgroundMobileMedia.type === 'VIDEO' && backgroundMobileMedia.mimeType === 'video/mp4'"
                                    [src]="backgroundMobileMedia.source"
                                    class="banner-background-video"
                                    autoplay muted loop playsinline>
                                    Your browser does not support the video tag. Please view the video content elsewhere.
                                </video>
                                <vsf-vimeo-player *ngIf="backgroundMobileMedia.type === 'VIDEO' && backgroundMobileMedia.mimeType === 'video/vimeo'"
                                    [source]="backgroundMobileMedia.customFields?.videoUrl || backgroundMobileMedia.source"
                                    [width]="backgroundMobileMediaWidth"
                                    [previewImageUrl]="backgroundMobileMedia.imageUrl || backgroundMobileMedia.preview"
                                    [previewAltText]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Video'">
                                </vsf-vimeo-player>
                            </div>
                            <div class="inner flex flex-row w-full relative z-[2]">
                                <div class="media-container" [ngStyle]="{'width': (button?.enabled && buttonPosition === 'below-text') ? '55%' : '100%' }">
                                    <div class="media-item">
                                        <ng-container *ngIf="isBrowser; else fallbackImage">
                                            <ng-container *ngTemplateOutlet="mobileMediaInSlide"></ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                                <div *ngIf="button?.enabled && buttonPosition === 'below-text'"
                                    class="flex flex-row justify-end" style="width: 45%;">
                                    <div class="text-container grid grid-rows-2">
                                        <div class="mt-6 text-right my-auto" style="width: 90%;">
                                            <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="font-bold"
                                                [ngStyle]="isMobile
                                                ? { 'font-size.px': mobileTitleFontSize }
                                                : { 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                                                [innerHTML]="title | safeHtml"></h1>
                                            <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="font-bold"
                                                [ngStyle]="isMobile
                                                ? { 'font-size.px': mobileTitleFontSize }
                                                : { 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                                                [innerHTML]="title | safeHtml"></div>
                                        </div>
                                        <div class="w-auto my-auto flex flex-row"
                                            [ngClass]="{
                                                'w-full justify-start': buttonAlignment === 'left',
                                                'w-full justify-end': buttonAlignment === 'right'
                                            }"
                                        >
                                            <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                                    <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="text-container mt-2 mb-4">
                            <div *ngIf="!(button?.enabled)">
                                <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="font-bold mb-2 rich-text-content"
                                    [ngStyle]="isMobile
                                    ? { 'font-size.px': mobileTitleFontSize, 'margin-left': '20px' }
                                    : { 'margin-left': titleIndentation,'font-size.px': titleFontSize }"
                                    [innerHTML]="title | safeHtml"></h1>
                                <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="font-bold mb-2 rich-text-content"
                                    [ngStyle]="isMobile
                                    ? { 'font-size.px': mobileTitleFontSize, 'margin-left': '20px' }
                                    : { 'margin-left': titleIndentation,'font-size.px': titleFontSize }"
                                    [innerHTML]="title | safeHtml"></div>
                            </div>
                            <div class="mb-4 rich-text-content"
                                [ngStyle]="isMobile
                                ? {'font-size.px': mobileTextFontSize, 'margin-left': '20px'}
                                : {'font-size.px': textFontSize}"
                                [innerHTML]="text | safeHtml"></div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>

            <div *ngIf="type === 'left-text-right-media'" class="banner-container left-text-right-media w-full">
                <div *ngIf="!isMobile" class="flex flex-row relative justify-between w-full">
                    <div class="banner-background overflow-hidden" *ngIf="backgroundMedia">
                        <img *ngIf="backgroundMedia.type === 'IMAGE'"
                            [src]="backgroundMedia | assetPreview:'full':'webp'"
                            [alt]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Image'"
                            class="w-full h-full object-cover"
                            [style.object-position]="backgroundMedia | focalPoint"
                            [style.opacity]="shadowTransparencyValue"
                        />
                        <video *ngIf="backgroundMedia.type === 'VIDEO' && backgroundMedia.mimeType === 'video/mp4'"
                            [src]="backgroundMedia.source"
                            class="banner-background-video"
                            autoplay muted loop playsinline>
                            Your browser does not support the video tag. Please view the video content elsewhere.
                        </video>
                        <vsf-vimeo-player *ngIf="backgroundMedia.type === 'VIDEO' && backgroundMedia.mimeType === 'video/vimeo'"
                            [source]="backgroundMedia.customFields?.videoUrl || backgroundMedia.source"
                            [width]="backgroundMediaWidth"
                            [previewImageUrl]="backgroundMobileMedia.imageUrl || backgroundMobileMedia.preview"
                            [previewAltText]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Video'">
                        </vsf-vimeo-player>
                    </div>
                    <div class="inner flex flex-col w-full relative z-[2]"
                        [style.padding]="linePadding"
                    >
                    <div>
                        <vsf-title-box
                            [titleInfo]="titleInfo"
                            [forComponent]="true">
                        </vsf-title-box>
                    </div>
                    <div class="flex flex-row">
                        <div class="text-container flex flex-col justify-center"
                            [ngStyle]="{ 'width': calculateWidths().text, 'text-align': textAlignment }">
                            <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="order-1 font-bold mb-3 rich-text-content"
                                    [ngStyle]="{ 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                                    [innerHTML]="title | safeHtml">
                            </h1>
                            <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="order-1 font-bold mb-3 rich-text-content"
                                    [ngStyle]="{ 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                                    [innerHTML]="title | safeHtml">
                            </div>
                            <div class="mb-4 order-2 rich-text-content"
                                [ngStyle]="{'margin-left': textIndentation,'width': textWidth,'font-size.px': textFontSize}"
                                [innerHTML]="text | safeHtml"></div>
                            <div *ngIf="button?.enabled && buttonPosition === 'below-text'"
                                class="flex flex-row mt-4 order-3"
                                [ngClass]="{
                                    'w-full justify-start': buttonAlignment === 'left',
                                    'w-full justify-end': buttonAlignment === 'right'
                                }"
                            >
                                <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                            </div>
                        </div>
                        <div class="media-container"
                            [ngClass]="{ 'ml-10':  mediaTextGap === 0 }"
                            [style.height.px]="mediaHeight"
                            [ngStyle]="{'width': calculateWidths().media, 'margin-left': mediaTextGap > 0 ? mediaTextGapInPx : null }">
                            <div class="media-item">
                                <ng-container *ngIf="isBrowser; else fallbackImage">
                                    <swiper-container appSwiper #rightMediaDesktopSwiper pagination.type="progressbar" pagination-clickable="true"
                                        centered-slides="true" lazy="true"
                                        rewind="true" class="flex-grow object-cover custom-pagination">
                                        <swiper-slide *ngFor="let media of bannerMedias"
                                            class="w-full h-full"
                                            [style.height.px]="mediaHeight"
                                        >
                                            <div class = "flex items-center w-full h-full"
                                                [ngClass]="{'justify-start'  : mediaTextGap > 0, 'justify-end': mediaTextGap == 0 }">
                                                <div *ngIf="media.type === 'IMAGE'">
                                                    <img [src]="media | assetPreview:'large':'webp'"
                                                        [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                        loading="eager"
                                                        style="pointer-events: none"
                                                        [style.height.px]="mediaHeight"
                                                        [width]="media.width"
                                                        [height]="media.height"
                                                        class="swiper-lazy w-full h-auto object-contain"
                                                        [ngClass]="roundedClass"/>
                                                    <div class="swiper-lazy-preloader"></div>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                                                    <video [muted]="true" class="object-cover w-full h-full"
                                                        style="pointer-events: none"
                                                        [style.height.px]="mediaHeight"
                                                        autoplay loop playsinline>
                                                        <source [src]="media.source" type="video/mp4">
                                                        Your browser does not support the video tag. Please view the video content elsewhere.
                                                    </video>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'">
                                                    <vsf-vimeo-player
                                                        [source]="media.customFields?.videoUrl || media.source"
                                                        [height]="mediaHeight"
                                                        [width]="mediasWidth"
                                                        [fullSection]="true"
                                                        [withMouseHover]="true"
                                                        [previewImageUrl]="media.imageUrl || media.preview"
                                                        [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                                                    </vsf-vimeo-player>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper-container>
                                </ng-container>
                            </div>
                        </div>
                        <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                            <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                        </div>
                    </div>
                    </div>
                </div>
                <div *ngIf="isMobile" class="w-full">
                  <div *ngIf="layoutStyle === 'normal'; else gridLayout">
                    <div class="flex flex-col" [style.padding]="linePadding">
                        <div>
                            <vsf-title-box
                                [titleInfo]="titleInfo"
                                [forComponent]="true">
                            </vsf-title-box>
                        </div>
                        <div class="flex flex-row overflow-hidden relative">
                            <div class="banner-background" *ngIf="backgroundMobileMedia">
                                <img *ngIf="backgroundMobileMedia.type === 'IMAGE'"
                                    [src]="backgroundMobileMedia | assetPreview:'medium':'webp'"
                                    class="w-full h-full object-cover"
                                    [style.object-position]="backgroundMobileMedia | focalPoint"
                                    [style.opacity]="shadowTransparencyValue"
                                />
                                <video *ngIf="backgroundMobileMedia.type === 'VIDEO' && backgroundMobileMedia.mimeType === 'video/mp4'"
                                    [alt]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Video'"
                                    class="banner-background-video"
                                    autoplay muted loop playsinline>
                                    <source [src]="media.source" type="video/mp4">
                                    Your browser does not support the video tag. Please view the video content elsewhere.
                                </video>
                                <vsf-vimeo-player *ngIf="backgroundMobileMedia.type === 'VIDEO' && backgroundMobileMedia.mimeType === 'video/vimeo'"
                                    [source]="backgroundMobileMedia.customFields?.videoUrl || backgroundMobileMedia.source"
                                    [width]="backgroundMobileMediaWidth"
                                    [previewImageUrl]="backgroundMobileMedia.imageUrl || backgroundMobileMedia.preview"
                                    [previewAltText]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Video'">
                                </vsf-vimeo-player>
                            </div>
                            <div class="inner flex flex-row w-full relative z-[2]">
                                <div *ngIf="button?.enabled && buttonPosition === 'below-text'" class="flex flex-row justify-start" style="width: 45%;">
                                    <div class="text-container grid grid-rows-2">
                                        <div class="mt-6 text-left my-auto" style="width: 90%;">
                                            <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="font-bold"
                                                [ngStyle]="{ 'font-size.px': mobileTitleFontSize }"
                                                [innerHTML]="title | safeHtml"></h1>
                                            <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="font-bold"
                                                [ngStyle]="{ 'font-size.px': mobileTitleFontSize }"
                                                [innerHTML]="title | safeHtml"></div>
                                        </div>
                                        <div class="w-auto my-auto flex flex-row"
                                            [ngClass]="{
                                                'w-full justify-start': buttonAlignment === 'left',
                                                'w-full justify-end': buttonAlignment === 'right'
                                            }"
                                        >
                                            <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                                        </div>
                                    </div>
                                </div>
                                <div class="media-container" [ngStyle]="{'width': (button?.enabled && buttonPosition === 'below-text') ? '55%' : '100%' }">
                                    <div class="media-item">
                                        <ng-container *ngIf="isBrowser; else fallbackImage">
                                            <ng-container *ngTemplateOutlet="mobileMediaInSlide"></ng-container>
                                        </ng-container>
                                    </div>
                                </div>
                                <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                                    <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="text-container mt-2 mb-4" [ngStyle]="{ 'text-align': textAlignment }">
                            <div *ngIf="!(button?.enabled) || buttonPosition === 'custom'">
                                <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="font-bold mb-2"
                                    [ngStyle]="{ 'font-size.px': mobileTitleFontSize, 'margin-left': '20px' }"
                                    [innerHTML]="title | safeHtml"></h1>
                                <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="font-bold mb-2"
                                    [ngStyle]="{ 'font-size.px': mobileTitleFontSize, 'margin-left': '20px' }"
                                    [innerHTML]="title | safeHtml"></div>
                            </div>
                            <div class="mb-4 rich-text-content"
                                [ngStyle]="{'font-size.px': mobileTextFontSize, 'margin-left': '20px'}"
                                [innerHTML]="text | safeHtml"></div>
                        </div>
                    </div>
                  </div>
                </div>
            </div>

            <div *ngIf="type === 'top-text-below-media'" class="banner-container top-text-below-media">
                <div class="inner flex flex-col w-full relative z-[2]"
                    [style.padding]="linePadding"
                >
                    <div>
                        <vsf-title-box
                            [titleInfo]="titleInfo"
                            [forComponent]="true">
                        </vsf-title-box>
                    </div>
                    <div class="text-container align-top w-full" [ngStyle]="{'text-align': textAlignment}">
                        <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="font-bold mb-4 rich-text-content"
                            [ngStyle]="isMobile
                            ? { 'font-size.px': mobileTitleFontSize }
                            : { 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                            [innerHTML]="title | safeHtml"></h1>
                        <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="font-bold mb-4 rich-text-content"
                            [ngStyle]="isMobile
                            ? { 'font-size.px': mobileTitleFontSize }
                            : { 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                            [innerHTML]="title | safeHtml"></div>
                        <div *ngIf="text" class="mb-4 rich-text-content"
                            [ngStyle]="isMobile
                            ? {'margin-left': textIndentation,'width': textWidth,'font-size.px': mobileTextFontSize}
                            : {'margin-left': textIndentation,'width': textWidth,'font-size.px': textFontSize}"
                            [innerHTML]="text | safeHtml"></div>
                    </div>
                    <ng-container *ngIf="!isMobile">
                    <div class="media-container">
                        <div class="media-item">
                            <ng-container *ngIf="isBrowser; else fallbackImage">
                                <ng-container *ngIf="bannerMedias.length > 3; else singleSlide">
                                    <swiper-container appSwiper #belowMediaMultipleSwiper
                                                        pagination="true"
                                                        pagination-type="bullets"
                                                        pagination-clickable="true"
                                                        [slidesPerView]="slidesPerView" space-between="30" rewind="true" lazy="true"
                                                        class="flex-grow object-cover under-container-pagination">
                                        <swiper-slide *ngFor="let media of bannerMedias" class="swiper-slide">
                                            <div class="flex justify-center items-center w-full h-full">
                                                <div *ngIf="media.type === 'IMAGE'">
                                                    <img [src]="media | assetPreview:'large':'webp'"
                                                        [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                        loading="eager"
                                                        style="pointer-events: none;"
                                                        [width]="media.width"
                                                        [height]="media.height"
                                                        class="swiper-lazy multi-slide-media w-full h-auto object-cover aspect-[1/1]"
                                                        [ngClass]="roundedClass"/>
                                                    <div class="swiper-lazy-preloader"></div>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                                                    <video [muted]="true"
                                                        class="multi-slide-media object-cover w-full h-full aspect-[1/1]"
                                                        style="pointer-events: none;"
                                                        autoplay loop playsinline>
                                                        <source [src]="media.source" type="video/mp4">
                                                        Your browser does not support the video tag. Please view the video content elsewhere.
                                                    </video>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'">
                                                    <vsf-vimeo-player
                                                        [source]="media.customFields?.videoUrl || media.source"
                                                        [width]="mediasWidth"
                                                        [fullSection]="true"
                                                        [withMouseHover]="true"
                                                        [previewImageUrl]="media.imageUrl || media.preview"
                                                        [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                                                    </vsf-vimeo-player>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper-container>
                                </ng-container>
                                <ng-template #singleSlide>
                                    <swiper-container appSwiper #belowMediaSingleSwiper autoplay="false" space-between="30" [slidesPerView]="slidesPerView"
                                                        class="flex-grow object-cover custom-pagination">
                                        <swiper-slide *ngFor="let media of bannerMedias" class="swiper-slide">
                                            <div class="flex justify-center items-center w-full">
                                                <div *ngIf="media.type === 'IMAGE'">
                                                    <img style="pointer-events: none;"
                                                        [src]="media | assetPreview:'large':'webp'"
                                                        [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                        loading="eager"
                                                        class="swiper-lazy single-slide-media w-full h-auto object-contain aspect-[16/9]"
                                                        [ngClass]="roundedClass"/>
                                                    <div class="swiper-lazy-preloader"></div>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                                                    <video [muted]="true" class="single-slide-media w-full h-full object-contain aspect-[16/9]"
                                                        style="pointer-events: none;" autoplay loop playsinline>
                                                        <source [src]="media.source" type="video/mp4">
                                                        Your browser does not support the video tag. Please view the video content elsewhere.
                                                    </video>
                                                </div>
                                                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'">
                                                    <vsf-vimeo-player
                                                        [source]="media.customFields?.videoUrl || media.source"
                                                        [width]="mediasWidth"
                                                        [height]="mediasHeight"
                                                        [fullSection]="true"
                                                        [withMouseHover]="true"
                                                        [previewImageUrl]="media.imageUrl || media.preview"
                                                        [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                                                    </vsf-vimeo-player>
                                                </div>
                                            </div>
                                        </swiper-slide>
                                    </swiper-container>
                                </ng-template>
                            </ng-container>
                        </div>
                    </div>
                    </ng-container>
                    <ng-container *ngIf="isMobile">
                        <div class="media-container" class="w-full">
                            <div class="media-item">
                                <ng-container *ngIf="mobileMediaStyle !== 'tiles'; else mobileMediaInTiles">
                                    <ng-container *ngIf="isBrowser; else fallbackImage">
                                        <ng-container *ngTemplateOutlet="mobileMediaInSlide"></ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                        <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="type === 'media-only'" class="banner-container media-only">
                <div class="inner flex flex-col w-full relative z-[2]"
                   [style.padding]="linePadding"
                >
                <div>
                    <vsf-title-box
                        [titleInfo]="titleInfo"
                        [forComponent]="true">
                    </vsf-title-box>
                </div>
                <div class="flex flex-row w-full">
                    <ng-container *ngIf="!isMobile">
                    <div class="media-container">
                        <div class="media-item">
                            <ng-container *ngIf="isBrowser; else fallbackImage">
                                <swiper-container appSwiper #mediaOnlySwiper pagination.type="progressbar" pagination-clickable="true"
                                    centered-slides="true" lazy="true" auto-height="true" rewind="true"
                                    class="flex-grow object-cover under-container-pagination">
                                    <swiper-slide *ngFor="let media of bannerMedias">
                                        <div class="flex justify-center items-center">
                                            <div *ngIf="media.type === 'IMAGE'">
                                                <img [src]="media | assetPreview:'full':'webp'"
                                                    [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                    loading="eager"
                                                    style="pointer-events: none;"
                                                    [width]="media.width"
                                                    [height]="media.height"
                                                    class="swiper-lazy w-full h-auto object-cover"
                                                    [ngClass]="roundedClass"/>
                                                <div class="swiper-lazy-preloader"></div>
                                            </div>
                                            <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                                                <video [muted]="true" class="w-full h-full object-cover"
                                                    style="pointer-events: none;" autoplay loop playsinline>
                                                    <source [src]="media.source" type="video/mp4">
                                                    Your browser does not support the video tag. Please view the video content elsewhere.
                                                </video>
                                            </div>
                                            <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'" [style.min-height.px]="mediaHeight">
                                                <vsf-vimeo-player
                                                    [source]="media.customFields?.videoUrl || media.source"
                                                    [width]="mediasWidth"
                                                    [height]="mediasHeight"
                                                    [fullSection]="true"
                                                    [withMouseHover]="true"
                                                    [previewImageUrl]="media.imageUrl || media.preview"
                                                    [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                                                </vsf-vimeo-player>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper-container>
                            </ng-container>
                        </div>
                    </div>
                    </ng-container>
                    <ng-container *ngIf="isMobile">
                        <div class="media-container" class="w-full">
                            <div class="media-item">
                                <ng-container *ngIf="mobileMediaStyle !== 'tiles'; else mobileMediaInTiles">
                                    <ng-container *ngIf="isBrowser; else fallbackImage">
                                        <ng-container *ngTemplateOutlet="mobileMediaInSlide"></ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                        <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                    </div>
                </div>
                </div>
            </div>

            <div *ngIf="type === 'titled-media'" class="banner-container media-only flex">
                <div class="inner flex flex-col w-full relative z-[2]"
                  [style.padding]="linePadding"
                >
                    <div>
                        <vsf-title-box
                            [titleInfo]="titleInfo"
                            [forComponent]="true">
                        </vsf-title-box>
                    </div>
                    <ng-container *ngIf="!isMobile">
                    <div class="media-container">
                        <div class="media-item">
                            <ng-container *ngIf="isBrowser; else fallbackImage">
                                <swiper-container appSwiper #titledMediaSwiper pagination.type="progressbar" pagination-clickable="true"
                                    auto-height="true" centered-slides="true" lazy="true" rewind="true"
                                    class="flex-grow object-cover under-container-pagination">
                                    <swiper-slide *ngFor="let media of bannerMedias">
                                        <div class="flex justify-center items-center w-full h-full">
                                            <div *ngIf="media.type === 'IMAGE'">
                                                <img [src]="media | assetPreview:'full':'webp'"
                                                    [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                    loading="eager"
                                                    style="pointer-events: none; height: auto;"
                                                    [width]="media.width"
                                                    [height]="media.height"
                                                    class="swiper-lazy w-full h-auto object-cover"
                                                    [ngClass]="roundedClass"/>
                                                <div class="swiper-lazy-preloader"></div>
                                            </div>
                                            <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                                                <video [muted]="true" class="w-full h-full object-cover"
                                                    style="pointer-events: none;" autoplay loop playsinline>
                                                    <source [src]="media.source" type="video/mp4">
                                                    Your browser does not support the video tag. Please view the video content elsewhere.
                                                </video>
                                            </div>
                                            <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'">
                                                <vsf-vimeo-player
                                                    [source]="media.customFields?.videoUrl || media.source"
                                                    [width]="mediasWidth"
                                                    [height]="mediasHeight"
                                                    [fullSection]="true"
                                                    [withMouseHover]="true"
                                                    [previewImageUrl]="media.imageUrl || media.preview"
                                                    [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                                                </vsf-vimeo-player>
                                            </div>
                                        </div>
                                    </swiper-slide>
                                </swiper-container>
                            </ng-container>
                        </div>
                    </div>
                    </ng-container>
                    <ng-container *ngIf="isMobile">
                        <div class="media-container" class="w-full">
                            <div class="media-item">
                                <ng-container *ngIf="mobileMediaStyle !== 'tiles'; else mobileMediaInTiles">
                                    <ng-container *ngIf="isBrowser; else fallbackImage">
                                        <ng-container *ngTemplateOutlet="mobileMediaInSlide"></ng-container>
                                    </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>
                    <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                        <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="(type === 'right-media-slide-with-background' || type === 'left-media-slide-with-background')&&!isMobile; else slideMediaMobile">
                <div *ngIf="type === 'left-media-slide-with-background'" class="banner-container left-media-slide-with-background">
                    <div class="banner-background" *ngIf="backgroundMedia">
                        <img *ngIf="backgroundMedia.type === 'IMAGE'"
                            [src]="backgroundMedia | assetPreview:'full':'webp'"
                            [alt]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Image'"
                            class="background-image"
                            [style.opacity]="shadowTransparencyValue"
                        />
                    </div>
                    <div class="inner flex flex-col w-full relative z-[2]"
                        [style.padding]="linePadding"
                    >
                    <div>
                        <vsf-title-box
                            [titleInfo]="titleInfo"
                            [forComponent]="true">
                        </vsf-title-box>
                    </div>
                    <div class="flex flex-row">
                        <div class="media-container mr-10" [style.height.px]="460" [ngStyle]="{'width': calculateWidths().media}">
                            <ng-container *ngIf="isBrowser; else fallbackLeftSlideImage">
                                <swiper-container
                                    appSwiper #leftSlideSwiper
                                    [slidesPerView]="1"
                                    pagination.type="progressbar"
                                    pagination-clickable="true"
                                    centered-slides="true"
                                    effect="fade"
                                    lazy="true"
                                    rewind="true"
                                    class="flex-grow object-cover custom-pagination">
                                    <swiper-slide *ngFor="let media of bannerMedias" [style.height.px]="330">
                                        <div class="flex justify-center items-center w-full h-full">
                                            <img *ngIf="media.type === 'IMAGE'"
                                                [src]="media | assetPreview:'large':'webp'"
                                                [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                style="width: 330px; height: 330px;"
                                                [width]="media.width"
                                                [height]="media.height"
                                                class="swiper-lazy w-full h-full object-contain"
                                                [ngClass]="roundedClass"
                                            />
                                            <div class="swiper-lazy-preloader"></div>
                                        </div>
                                    </swiper-slide>
                                </swiper-container>
                            </ng-container>
                            <ng-template #fallbackLeftSlideImage>
                                <ng-container *ngTemplateOutlet="fallbackSliderTemplate; context: {isMobile: isMobile}"></ng-container>
                            </ng-template>
                        </div>
                    </div>
                    <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                        <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                    </div>
                    </div>
                </div>
                <div *ngIf="type === 'right-media-slide-with-background'" class="banner-container right-media-slide-with-background">
                    <div class="banner-background" *ngIf="backgroundMedia">
                        <img *ngIf="backgroundMedia.type === 'IMAGE'"
                            [src]="backgroundMedia | assetPreview:'full':'webp'"
                            [alt]="backgroundMedia.customFields?.altText ? backgroundMedia.customFields?.altText : 'Marketing Banner Image'"
                            class="background-image"
                            [style.opacity]="shadowTransparencyValue"
                        />
                    </div>
                    <div
                        class="inner flex flex-col w-full relative z-[2]"
                        [ngStyle]="{ padding: linePadding }"
                    >
                    <div>
                        <vsf-title-box
                            [titleInfo]="titleInfo"
                            [forComponent]="true">
                        </vsf-title-box>
                    </div>
                    <div class="flex flex-row-reverse">
                        <div class="media-container ml-10" [style.height.px]="460" [ngStyle]="{'width': calculateWidths().media}">
                            <ng-container *ngIf="isBrowser; else fallbackRightSlideImage">
                                <swiper-container
                                    [observer]="true"
                                    appSwiper #rightSlideSwiper
                                    [slidesPerView]="1"
                                    pagination.type="bullets"
                                    pagination-clickable="true"
                                    centered-slides="true"
                                    lazy="true"
                                    effect="fade"
                                    rewind="true"
                                    class="flex-glow object-cover custom-pagination">
                                    <swiper-slide *ngFor="let media of bannerMedias" [style.height.px]="330">
                                        <div class="flex justify-center items-center w-full h-full">
                                            <img *ngIf="media.type === 'IMAGE'"
                                                [src]="media | assetPreview:'large':'webp'"
                                                [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                                style="width: 330px; height: 330px;"
                                                [width]="media.width"
                                                [height]="media.height"
                                                class="swiper-lazy w-full h-full object-contain"
                                                [ngClass]="roundedClass"
                                            />
                                            <div class="swiper-lazy-preloader"></div>
                                        </div>
                                    </swiper-slide>
                                </swiper-container>
                            </ng-container>
                            <ng-template #fallbackRightSlideImage>
                                <ng-container *ngTemplateOutlet="fallbackSliderTemplate; context: {isMobile: isMobile}"></ng-container>
                            </ng-template>
                        </div>
                    </div>
                    <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                        <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                    </div>
                    </div>
                </div>
            </div>
            <ng-template #slideMediaMobile>
                <div *ngIf="isMobile && (type === 'right-media-slide-with-background' || type === 'left-media-slide-with-background')"
                     class="slide-media-mobile relative h-auto flex flex-col">
                    <div class="w-full h-auto object-cover"
                        *ngIf="backgroundMobileMedia">
                        <img *ngIf="backgroundMobileMedia.type === 'IMAGE'"
                            [src]="backgroundMobileMedia | assetPreview:'medium':'webp'"
                            [alt]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Image'"
                            [width]="backgroundMobileMedia.width"
                            [height]="backgroundMobileMedia.height"
                            loading="eager"
                            decoding="async"
                            fetchpriority="high"
                            class="background-image w-full h-auto object-cover"
                            [style.object-position]="backgroundMobileMedia | focalPoint"
                        />
                    </div>
                    <div class="media-container absolute"
                        [ngClass]="getMediaContainerClass(mobileMediaPosition)">
                        <ng-container *ngIf="isBrowser; else fallbackMobileSlideImage">
                            <swiper-container
                                appSwiper #mobileSlideSwiper
                                [observer]="true"
                                [slidesPerView]="1"
                                pagination.type="bullets"
                                pagination-clickable="true"
                                centered-slides="true"
                                effect="fade"
                                lazy="true"
                                rewind="true"
                                class="flex-glow object-cover custom-pagination">
                                <swiper-slide *ngFor="let media of bannerMedias">
                                    <div class="flex justify-center items-center w-full h-full">
                                        <img *ngIf="media.type === 'IMAGE'"
                                            style="width: 75%; height: 75%;"
                                            [src]="media | assetPreview:'small':'webp'"
                                            [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                                            [width]="media.width"
                                            [height]="media.height"
                                            loading="eager"
                                            decoding="async"
                                            fetchpriority="low"
                                            class="swiper-lazy w-full h-full object-contain"
                                            [ngClass]="roundedClass"
                                        />
                                        <div class="swiper-lazy-preloader"></div>
                                    </div>
                                </swiper-slide>
                            </swiper-container>
                        </ng-container>
                        <ng-template #fallbackMobileSlideImage>
                            <ng-container *ngTemplateOutlet="fallbackSliderTemplate; context: {isMobile: isMobile}"></ng-container>
                        </ng-template>
                    </div>
                    <div *ngIf="button?.enabled && buttonPosition === 'custom'" [ngStyle]="getButtonStyles()">
                        <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                    </div>
                </div>
            </ng-template>
        </div>
    </ng-template>
</div>

<!-- Define the fallback image template -->
<ng-template #bannerButton>
    <button
        (click)="buttonClick($event)"
        class="button rounded-lg"
        [class.mx-auto]="buttonPosition === 'below-text' && buttonAlignment === 'center'"
        [ngStyle]="{'background-color': button?.backgroundColor, 'color': button?.textColor, 'white-space': 'nowrap'}"
        [disabled]="inFlight"
    >
        <span [innerHTML]="button.text | safeHtml"></span>
    </button>
</ng-template>
<ng-template #fallbackImage>
    <div class="fallback-image-container" [style.min-height.px]="mediaHeight" style="display:flex; justify-content:center; align-items:center; background:#f0f0f0;">
        <ng-container *ngIf="bannerMedias && bannerMedias.length > 0">
            <ng-container *ngIf="bannerMedias[0].type === 'IMAGE'">
                <img
                    [src]="bannerMedias[0] | assetPreview: ((type === 'media-only' || type === 'titled-media') ? 'full' : (isMobile ? 'medium' : 'large')):'webp'"
                    [alt]="bannerMedias[0].customFields?.altText ? bannerMedias[0].customFields?.altText : 'Marketing Banner Image'"
                    class="w-full h-auto object-cover"
                    [style.object-position]="bannerMedias[0] | focalPoint"
                    [ngClass]="roundedClass"
                />
            </ng-container>
        </ng-container>
    </div>
</ng-template>
<ng-template #fallbackSliderTemplate>
    <div
      class="flex justify-center items-center w-full h-full"
      [ngStyle]="isMobile
        ? { 'width': '75%', 'height': '75%', 'margin': 'auto' }
        : { 'height.px': 330 }"
    >
      <ng-container *ngIf="bannerMedias && bannerMedias.length > 0 && bannerMedias[0].type === 'IMAGE'; else noFallbackMedia">
        <img
          [src]="bannerMedias[0] | assetPreview:(isMobile ? 'small' : 'large'):'webp'"
          [alt]="bannerMedias[0].customFields?.altText ? bannerMedias[0].customFields?.altText : 'Marketing Banner Image'"
          [ngStyle]="isMobile
            ? { 'width': '100%', 'height': '100%' }
            : { 'width.px': 330, 'height.px': 330 }"
          [width]="bannerMedias[0].width"
          [height]="bannerMedias[0].height"
          class="w-full h-full object-contain"
          [ngClass]="roundedClass"
        />
      </ng-container>
    </div>
</ng-template>
<ng-template #gridLayout>
    <div class="grid grid-cols-1 gap-4 mx-2 my-2">
        <div [ngClass]="{'order-first': mobileMediaPosition === 'top', 'order-last': mobileMediaPosition === 'bottom'}">
            <div class="flex flex-row overflow-hidden relative">
                <div class="banner-background" *ngIf="backgroundMobileMedia">
                    <img *ngIf="backgroundMobileMedia.type === 'IMAGE'"
                        [src]="backgroundMobileMedia | assetPreview:'medium':'webp'"
                        [alt]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Image'"
                        class="w-full h-full object-cover"
                        [style.object-position]="backgroundMobileMedia | focalPoint"
                    />
                    <video *ngIf="backgroundMobileMedia.type === 'VIDEO' && backgroundMobileMedia.mimeType === 'video/mp4'"
                        [src]="backgroundMobileMedia.source"
                        class="banner-background-video"
                        autoplay muted loop playsinline>
                        Your browser does not support the video tag. Please view the video content elsewhere.
                    </video>
                    <vsf-vimeo-player *ngIf="backgroundMobileMedia.type === 'VIDEO' && backgroundMobileMedia.mimeType === 'video/vimeo'"
                        [source]="backgroundMobileMedia.customFields?.videoUrl || backgroundMobileMedia.source"
                        [width]="backgroundMobileMediaWidth"
                        [previewImageUrl]="backgroundMobileMedia.imageUrl || backgroundMobileMedia.preview"
                        [previewAltText]="backgroundMobileMedia.customFields?.altText ? backgroundMobileMedia.customFields?.altText : 'Marketing Banner Video'">
                    </vsf-vimeo-player>
                </div>
                <div class="media-container">
                    <div class="media-item">
                        <ng-container *ngIf="mobileMediaStyle !== 'tiles'; else mobileMediaInTiles">
                            <ng-container *ngIf="isBrowser; else fallbackImage">
                                <ng-container *ngTemplateOutlet="mobileMediaInSlide"></ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div [ngClass]="{'order-first': mobileMediaPosition === 'bottom', 'order-last': mobileMediaPosition === 'top'}">
            <div *ngIf="button?.enabled && buttonPosition === 'custom' && (buttonLocationYMobile === 0)" [ngStyle]="getButtonXLocationStyles()">
                <div class="text-center my-auto">
                    <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                </div>
            </div>
            <div class="text-container w-full mt-2 mb-4"
                [ngStyle]="{ 'text-align': textAlignment }">
                <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" class="font-bold mb-4 rich-text-content"
                    [ngStyle]="isMobile
                    ? { 'font-size.px': mobileTitleFontSize }
                    : { 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                    [innerHTML]="title | safeHtml"></h1>
                <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" class="font-bold mb-4 rich-text-content"
                    [ngStyle]="isMobile
                    ? { 'font-size.px': mobileTitleFontSize }
                    : { 'margin-left': titleIndentation, 'font-size.px': titleFontSize }"
                    [innerHTML]="title | safeHtml"></div>
                <div class="mb-4 rich-text-content"
                    [ngStyle]="isMobile
                    ? {'font-size.px': mobileTextFontSize}
                    : {'font-size.px': textFontSize}"
                    [innerHTML]="text | safeHtml"></div>
            </div>
            <div *ngIf="button?.enabled && buttonPosition === 'below-text'" class="w-full">
                <div class="w-auto my-auto flex flex-row"
                    [ngClass]="{
                        'w-full justify-start': buttonAlignment === 'left',
                        'w-full justify-end': buttonAlignment === 'right'
                    }"
                >
                    <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                </div>
            </div>
            <div *ngIf="button?.enabled && buttonPosition === 'custom' && (buttonLocationYMobile < 1 && buttonLocationYMobile > 0)" [ngStyle]="getButtonStyles()">
                <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
            </div>
            <div *ngIf="button?.enabled && buttonPosition === 'custom' && (buttonLocationYMobile === 1)" [ngStyle]="getButtonXLocationStyles()">
                <div class="text-center my-auto">
                    <ng-container *ngTemplateOutlet="bannerButton"></ng-container>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #mobileMediaInSlide>
    <swiper-container appSwiper #mobileMediaSwiper pagination.type="progressbar" pagination-clickable="true"
        centered-slides="true" auto-height="true" lazy="true" rewind="true"
        class="flex-grow object-cover custom-pagination">
        <swiper-slide *ngFor="let media of bannerMedias">
            <div class="flex justify-center md:justify-end items-center w-full h-full">
                <div *ngIf="media.type === 'IMAGE'" class="w-full">
                    <img loading="eager"
                        [src]="media | assetPreview:mobileImageSize:'webp'"
                        [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                        style="pointer-events: none; height: auto;"
                        [width]="media.width"
                        [height]="media.height"
                        class="swiper-lazy h-auto object-contain"
                        [ngClass]="roundedClass"/>
                    <div class="swiper-lazy-preloader"></div>
                </div>
                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
                    <video [muted]="true" class="object-cover w-full h-full object-contain"
                        style="pointer-events: none; height: auto;"
                        autoplay loop playsinline>
                        <source [src]="media.source" type="video/mp4">
                        Your browser does not support the video tag. Please view the video content elsewhere.
                    </video>
                </div>
                <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'" class="w-full h-full">
                    <div class="flex justify-center items-center w-full">
                        <vsf-vimeo-player
                            [source]="media.customFields?.videoUrl || media.source"
                            [width]="mediasWidth"
                            [height]="mediasHeight"
                            [fullSection]="true"
                            [withMouseHover]="true"
                            [previewImageUrl]="media.imageUrl || media.preview"
                            [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
                        </vsf-vimeo-player>
                    </div>
                </div>
            </div>
        </swiper-slide>
    </swiper-container>
</ng-template>
<ng-template #mobileMediaInTiles>
    <!-- Remove extra flex classes so each media is a block-level element -->
    <div *ngFor="let media of bannerMedias" class="w-full my-2">
        <!-- IMAGE case -->
        <div *ngIf="media.type === 'IMAGE'">
        <img [src]="media | assetPreview:'medium':'webp'"
                loading="eager"
                [alt]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Image'"
                style="pointer-events: none;"
                [width]="media.width"
                [height]="media.height"
                class="w-full h-auto object-contain"
                [ngClass]="roundedClass"/>
        </div>
        <!-- VIDEO (MP4) case -->
        <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'">
        <video [muted]="true"
                class="w-full h-auto object-contain"
                style="pointer-events: none;"
                autoplay loop playsinline>
            <source [src]="media.source" type="video/mp4">
            Your browser does not support the video tag. Please view the video content elsewhere.
        </video>
        </div>
        <!-- VIDEO (Vimeo) case -->
        <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo'">
        <div class="flex justify-center items-center w-full my-2">
            <vsf-vimeo-player
                [source]="media.customFields?.videoUrl || media.source"
                [width]="mediasWidth"
                [height]="mediasHeight"
                [fullSection]="true"
                [withMouseHover]="true"
                [previewImageUrl]="media.imageUrl || media.preview"
                [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Marketing Banner Video'">
            </vsf-vimeo-player>
        </div>
        </div>
    </div>
</ng-template>
